// *********************************
// Code generated by sdkgen
// DO NOT EDIT!
//
// Internal module that provides ApiServices to your exposed sdk module.
// *********************************
import { NgModule } from '@angular/core';
import { HostService } from '../_generated/host.service';
import { AdminCenterApiService } from './admin-center.api.service';
import { SearchApiService } from './search.api.service';
import { TemplateApiService } from './template.api.service';

@NgModule({
  imports: [],
  providers: [AdminCenterApiService, SearchApiService, TemplateApiService, HostService],
  declarations: [],
  exports: [],
})
export class WspAdminCenterInternalModule {}
